module.exports = __webpack_public_path__ + "static/media/strategy2.34fd0e0b.jpg";